module.exports = __webpack_public_path__ + "assets/img/open1.1.5c07a96f.svg";